export enum EvFieldWriteModeEnum {
  SKIP = "SKIP",
  APPEND = "APPEND",
  OVERWRITE = "OVERWRITE",
}
